import { render, staticRenderFns } from "./ChatItemTask.vue?vue&type=template&id=e6aeb62a&"
import script from "./ChatItemTask.vue?vue&type=script&lang=js&"
export * from "./ChatItemTask.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports